import StaffIndex from "@/views/staff/StaffIndex.vue";

const staff = [
  {
    path: "/staff",
    name: "staff",
    component: StaffIndex,
    meta: {
      layout: "default",
      role: ["superadmin","backoffice","supervisor"],
      public: false,
    },
  },
];

export default staff;
